export default {
  components: {},
  props: {},
  data() {
    return {
      isYiCurdLoaded: false,
    };
  },
  computed: {
    yt() {
      if (this.isYiCurdLoaded) {
        return this.$refs.yt;
      } else {
        return {
          exportLoading: false,
          loading: false,
          editObj: {
            loading: false,
          },
          conditions: {},
          pageNum: 0,
          pageSize: 10,
          dialogWidth: "0", //默认就用字符串，以免报错
          dialogWidths: {},
          formLabelWidth: 0,
          formLabelWidths: {},
          isShowEditDialog: false,
        };
      }
    },
  },
  created() {},

  mounted() {},
  methods: {},

  watch: {},
};
